import styled, { css } from 'styled-components';

export const BookingSummaryCategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BookingSummaryCategoryTitle = styled.span`
  width: 100%;
  padding-top: 1.4rem;
  font-weight: 600;
  font-size: 1.6rem;
  text-align: center;
  margin-bottom: 1rem;
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
`;

export const BookingSummaryCategorySectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BookingSummaryColumnSection = styled.div<{ textAlign?: string }>`
  width: 50%;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'start')};
`;

export const BookingSummaryCategoryPriceSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const BookingSummaryCategorySpan = styled.span<{ bold?: boolean }>`
  ${({ bold }) =>
    bold
      ? css`
          font-weight: 600;
          font-size: 2rem;
          line-height: 3rem;
        `
      : css`
          font-size: 1.28rem;
          line-height: 1.8rem;
          font-weight: 400;
        `};
`;

export const BookingSummaryDiscountSpan = styled(BookingSummaryCategorySpan)`
  color: ${({ theme: { colors } }) => colors.b2cRed};
`;

export const BookingSummaryCategoryParagraph = styled.p`
  font-size: 1.28rem;
  margin: 0;
  margin-bottom: 1rem;
  color: ${({ theme: { colors } }) => colors.b2cGrey};
`;
